import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayOnSmallMultiSelectPipe'
})
export class DisplayOnSmallMultiSelectPipe implements PipeTransform {

  transform(value: any): any {
    let output = value;
    if (output.length > 15) {
      return output.substring(0, 15) + "...";
    } else {
      return output;
    }
  }

}
